import type { TagDto } from '@pulsify/shared/dto'
import { api, unwrap } from '~/shared/lib/rpc'

type Tag = TagDto

export const tagsApi = {
  async getAll(): Promise<Tag[]> {
    const res = await api.api.tags.$get()
    const body = await unwrap<Tag[]>(res)
    return body
  },

  async getForUserOnboarding(): Promise<Tag[]> {
    const res = await api.api.tags.onboarding.$get()
    const body = await unwrap<Tag[]>(res)
    return body
  },
}
